import React, {ReactNode} from "react";
import LinkArrow from "@/Components/Icons/LinkArrow";

interface Props {
    style?: 'danger' | 'success' | 'info' | 'warning',
    icon?: ReactNode,
    children: ReactNode,
    action?: ReactNode,
    className?: string,
    showArrow?: boolean
}
export default function AlertWithAction({
                                            style = "info",
                                            icon = (<></>),
                                            children,
                                            action = (<></>),
                                            className = "",
                                            showArrow = true
                                        }: Props) {
    const baseClass = "text-sm py-3 px-4 flex rounded gap-x-2 items-center";
    let styledClass = function () {
        switch (style) {
            case "danger":
                return "bg-red-50 text-red-600 stroke-red-600";
            case "success":
                return "bg-green-50 text-green-600 stroke-green-600";
            case "warning":
                return "bg-yellow-50 text-yellow-600 stroke-yellow-600";
            default:
                return "bg-indigo-50 text-indigo-600 stroke-indigo-600";
        }
    }();
    return (
        <div className={`${baseClass} ${styledClass} ${className}`}>
            {icon && (<>{icon}</>)}
            {children}
            {action && (
                <div className="underline font-bold flex items-center gap-x-2">{action} {showArrow ? <LinkArrow/> : <></>}</div>
            )}

        </div>
    );
}
